<script>
    import * as urls from "../json/config.json";
    import Spinner from './spinner.svelte';
    import { token } from "./store";

    let approval_email = ""
    let approve_message = "Enter the email id to approve.  Make sure you have done your due diligence to check this user.";
    let error_message = ""

    let spinner = false;
    
    function validateEmail(email) {
        var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    }

    const handleApproval = async (email) => {
        if (email == "" ){
            error_message = "Email is required"
        }

        if (!validateEmail(email)){
            error_message = "Not a valid email address"
            return
        }

        error_message = ""
        let formData = new FormData();
        formData.append('email', email);

        try{
            spinner = true
            const response = await fetch(urls.approve, {
                method: 'POST',
                body: formData,
                headers: {
					'Authorization': 'Bearer ' + $token
				},
            });
            spinner = false
            if(response.ok) {
                approve_message = email + " approved successfully"
            }
            else {
                error_message = "Something went wrong while approving " + email;
            }
        } catch (error) {
            console.log(error)
            throw new Error('An error occurred:', error);
        }
    }
</script>

<div class="spinner">
    {#if spinner === true}
        <Spinner/>
    {/if}
</div>

<div class="container">
    <form class="login" on:submit|preventDefault={handleApproval(approval_email)}>
        <p class="info">{approve_message}</p><br>
        {#if (error_message != undefined || error_message != "")}
            <div class = "error">{error_message}</div>
        {/if}

        <label for="email"></label>
        <input type="email" id="email" placeholder="Email" bind:value={approval_email} required><br>
            <button type="submit" class="login-buttons">
                Approve
            </button>
    </form>
</div>

<style>
    .container{
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    }
    .login{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 15px;
        margin-bottom: 15px;
        width: 100%;
    }
    .info{
        width: 50%;
        text-align: center;
    }
    #email{
        width: 250px;
        margin-top: 5px;
        margin-bottom: 5px;
    }
    .login-buttons{
		height: 30px;
		max-height: 30px;
		flex-grow: 0;
		font-size: 0.9rem;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		gap: 10px;
		padding: 10px 15px;
		border-style: solid;
		border-width: 3px;
		border-image-source: linear-gradient(112deg, #9c0ccf 0%, #5157d4 100%);
		border-image-slice: 1;
		border-radius: 4px;
		background-image: linear-gradient(112deg, #9c0ccf 0%, #5157d4 100%);
		color: ghostwhite;
		cursor: pointer;
		box-sizing: border-box;
	}
    .error{
        color: #ff0063;

    }
    .spinner{
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
        z-index: 1000;
	}
</style>